export const mergeToNewObject = (objectOne, objectTwo) => Object.assign({}, objectOne, objectTwo)

export const isInvalid = isValid => isValid === false

export function logger(value) {
  if (process.env.REACT_APP_ENV === 'production') return

  console.log(value)
}

export function containsNoFalseProp(obj) {
  return !Object.entries(obj).some(([_, value]) => value === false)
}

export function containsNoErrors(obj) {
  return !Object.entries(obj).some(([_, value]) => value !== '')
}

export function removeTicks(str) {
  return str.split('').filter(el => el !== "'").join('')
}

export function addTicks(num, rest='') {
  const str = num.toString()    
  const newRest = rest ? `'${rest}` : ''
  if (str.length <= 3) return str + newRest
  return addTicks(str.slice(0, -3), str.slice(-3) + newRest)
}

export function sliceArrayToString(arr, begin, end) {
  return arr.slice(begin, end).join('')
}

export function parseUrlParams(str) {
  const parsedObj = {}

  if (!str) return parsedObj
  
  str.substring(1).split("&").forEach(prop => {
    const [ key, value ] = prop.split("=")
    parsedObj[key] = value    
  })
  
  return parsedObj
}

export function validateEmail(email) {
  const valid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return valid.test(email)
}

export function refreshPage() {
  window.location.reload()
}

export function isValidImage(files) {
  if (files.length && files[0].size < 1000000) {
    const extension = files[0].name.slice(-3)
    switch (extension) {
      case 'png':
      //case 'jpg':
      //case 'svg':
        return true
    
      default:
        return false
    }
  }
  return false
}


// WEBPACK FOOTER //
// ./src/util/helpers.js